import { render } from "./Formato1999.vue?vue&type=template&id=082718ce&scoped=true"
import script from "./Formato1999.vue?vue&type=script&lang=js"
export * from "./Formato1999.vue?vue&type=script&lang=js"

import "./Formato1999.vue?vue&type=style&index=0&id=082718ce&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082718ce"]])

export default __exports__